import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import App from "./App.jsx";

window.appConfig = createAppConfig();

createRoot(document.getElementById("root")).render(<App/>);

function createAppConfig() {
    const envName = import.meta.env.VITE_REACT_APP_ENV_NAME;
    if (!envName) throw new Error("ENV_NAME is not set");

    let msLoginBaseUrl =
        "https://mslogin-" + envName + ".iam-nonprod.collegeboard.org";
    if (envName === "prod") {
        msLoginBaseUrl = "https://mslogin.collegeboard.org";
    }
    if (!msLoginBaseUrl) throw new Error("MSLOGIN_URL is not set");

    let baseUrl = "https://account-" + envName + ".iam-nonprod.collegeboard.org";
    if (envName === "prod") {
        baseUrl = "https://account.collegeboard.org";
        // TODO: this url is used to shake out prod buildout, should switch to account.collegeboard.org after confirming the prod buildout is working as expected
        //baseUrl = "Https://origin-9f3c2a61-8d74-4b2e-9c1a-6e5f4b8d7a03.iam-prod.collegeboard.org";
    }

    const baseUrlWithProxy = "https://account.collegeboard.org";

    if (!baseUrl) throw new Error("BASE_URL is not set");

    let oktaEnv = "dev";
    if (envName === "prod") {
        oktaEnv = "prod";
    }
    if (envName === "palm" || envName === "apple" || envName === "maple") {
        oktaEnv = "qa";
    }
    if (envName === "spruce") {
        oktaEnv = "preprod";
    }

    return {
        envName,
        msLoginBaseUrl: msLoginBaseUrl,
        oktaEnv,
        baseUrl,
        baseUrlWithProxy,
    };
}
